import { Component, Input, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-all-products',
  templateUrl: './select-all-products.component.html',
  styleUrls: ['./select-all-products.component.scss']
})
export class SelectAllProductsComponent implements OnDestroy {

  @Input() showAll: boolean = false;
  public items: any[] = [
    { name: 'Desglose Producto', value: true },
    { name: 'Solo 1 Producto', value: false }
  ];

  public productTypeAll: any = [];
  public ngxDisabled = false;
  productTypeAll$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.productTypeAll$ = this.sharedService.sharedAllProducts.subscribe(productTypeAll => {
      if (this.productTypeAll !== productTypeAll) {
        this.productTypeAll = productTypeAll;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnInit() {
    if (this.showAll) {
      this.sharedService.nextAllProducts = true;
    }
  }

  ngOnDestroy() {
    this.productTypeAll$.unsubscribe();
  }

  changeProductAll(event: any) {
    this.productTypeAll = event;
    this.sharedService.nextAllProducts = this.productTypeAll;
    if(event) this.sharedService.nextProductGasolineDefault = '';
  }
}
